interface Permission {
  module: string;
  action: string;
}

/**
 * Parses a permission string into module and action
 * @param permission Permission string in format "module.action"
 * @returns Object containing module and action
 */
const parsePermission = (permission: string): Permission => {
  const [module, action] = permission.split(".");
  return { module, action };
};

/**
 * Gets all viewable modules from permissions array
 * @param permissions Array of permission strings
 * @returns Array of module names that are viewable
 */
export const getViewableModules = (permissions: string[]): string[] => {
  return permissions
    .filter((perm) => perm.endsWith(".view"))
    .map((perm) => parsePermission(perm).module);
};

/**
 * Checks if a module is viewable based on permissions
 * @param module Module name to check
 * @param permissions Array of permission strings
 * @returns Boolean indicating if module is viewable
 */
export const isModuleViewable = (
  module: string,
  permissions: string[]
): boolean => {
  return permissions.includes(`${module}.view`);
};

/**
 * Maps module names to their corresponding menu paths
 */
export const MODULE_MENU_MAP: { [key: string]: string } = {
  dashboard: "/business",
  stock: "/business/stock-management",
  menu: "/business/menu",
  bom: "/business/menu/bom",
  suppliers: "/business/suppliers",
  pos: "/business/pos",
  cashiers: "/business/cashiers",
  customers: "/business/customers",
  reports: "/business/reports",
  settings: "/business/settings",
  facilities: "/business/facilities",
  staff: "/business/configuration/staff",
  configuration: "/business/configuration",
  orders: "/business/orders",
};

/**
 * Maps menu paths to their corresponding module names
 */
export const MENU_MODULE_MAP: { [key: string]: string } = Object.entries(
  MODULE_MENU_MAP
).reduce(
  (acc, [module, path]) => ({
    ...acc,
    [path]: module,
  }),
  {}
);
